import { useCallback, useEffect, useState } from 'react';

import { useDelayedResizeObserver } from './use-delayed-resize-observer';

export function useContentTruncationDetector(
	contentRef: React.RefObject<HTMLDivElement>,
	containerRef: React.RefObject<HTMLDivElement>,
	collapsed: boolean,
	additionalDeps: React.DependencyList = [],
): boolean {
	const [isContentTruncated, setIsContentTruncated] = useState(false);

	// Only measure when collapsed is true
	const measureTruncation = useCallback(() => {
		if (!collapsed) {
			return;
		}
		if (contentRef.current && containerRef.current) {
			const contentHeight = contentRef.current.getBoundingClientRect().height;
			const containerHeight = containerRef.current.getBoundingClientRect().height;
			setIsContentTruncated(contentHeight > containerHeight);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [collapsed, contentRef, containerRef, ...additionalDeps]);

	// Measure truncation and reset state when collapsed state changes
	useEffect(() => {
		if (!collapsed) {
			setIsContentTruncated(false);
			return;
		}
		measureTruncation();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [collapsed, contentRef, containerRef, ...additionalDeps]);

	useDelayedResizeObserver(contentRef, measureTruncation);

	return isContentTruncated;
}
